// @flow

import type { TableHeader } from "buba-components/src/components/Table/Table";
import type { BankOfferStatus } from "../../data/types/bankOffers";
import { isCustomerInquiry } from "./InquiriesList";
import type { InquiryStatus } from "../../data/types/inquiries";

const getBankTimeTableHeader = (tabId: BankOfferStatus | InquiryStatus) => {
  switch (tabId) {
    case "new":
      return "Vorprüfung notwendig bis in";
    case "in_progress":
      return "Genehmigung notwendig bis in";
    case "offer_submitted":
      return "Gewähltes Auszahlungsdatum";
    case "closed":
      return "Anfrage geschlossen am";
    default:
      return "";
  }
};

const getCustomerHeadersConfig = tabId => [
  { columnId: "id", label: "ID", sort: true },
  { columnId: "created_at", label: "Erstellt am", sort: true },
  { columnId: "bankTime", label: getBankTimeTableHeader(tabId), sort: false },
  { columnId: "company", label: "Unternehmen", sort: true },
  { columnId: "amount", label: "Volumen", sort: true },
  { columnId: "collaterals", label: "Besicherung bewilligt", sort: false },
  { columnId: "status", label: "Status", sort: true }
];

const getBankAdvisorHeadersConfig = () => [
  { columnId: "id", label: "ID", sort: true },
  { columnId: "created_at", label: "Erstellt am", sort: true },
  { columnId: "company", label: "Unternehmen", sort: true },
  { columnId: "amount", label: "Volumen", sort: true },
  { columnId: "status", label: "Status", sort: true }
];

const sortingDecorator = (header, sort) => {
  const { columnId } = header;

  return header.sort
    ? {
        ...header,
        ascSort: () => {
          sort(columnId, "asc");
        },
        descSort: () => {
          sort(columnId, "desc");
        }
      }
    : header;
};

// eslint-disable-next-line import/prefer-default-export
export const getTableHeaders: (
  (string, "asc" | "desc") => void,
  type: "customer" | "bankAdvisor",
  BankOfferStatus | InquiryStatus
) => TableHeader[] = (sort, type, tabId) => {
  const isInquiryTab = isCustomerInquiry(type);
  const config = isInquiryTab ? getCustomerHeadersConfig(tabId) : getBankAdvisorHeadersConfig();

  return config.map(header => sortingDecorator(header, sort));
};
